var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHtml(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 42 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.35334 49.6639L0.75 10.6133H41.25L36.6436 49.6578L20.9768 54.001L5.35334 49.6639ZM14.6627 28.2896L14.225 23.385H32.5522L32.981 18.5956H8.99085L10.2826 33.0789H26.8811L26.3253 39.2903L20.9836 40.7321L20.9798 40.7336L15.6459 39.2934L15.3049 35.4736H10.4971L11.1681 42.9938L20.9788 45.7172L30.8021 42.9935L31.9996 29.5757L32.1163 28.2896H14.6627Z",
    fill: "#B42F53"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHtml);
export default __webpack_public_path__ + "static/media/html.ed223721dcbb42ffef332034cf1eda82.svg";
export { ForwardRef as ReactComponent };